export const slugAlias = {
  "what-is-forex": "1-1-1-what-is-forex",
  "what-is-a-commodity": "1-1-2-what-is-a-commodity",
  "what-is-an-index":  "1-1-3-what-is-an-index",
  "what-is-a-share": "1-1-4-what-is-a-share",
  "what-is-a-cfd": "1-1-5-what-is-a-cfd",
  "pips-points-and-tricks": "1-2-1-pips-points-and-tricks",
  "balance-and-equity": "1-2-2-balance-and-equity",
  "bull-and-bear-market": "1-2-3-bull-and-bear-market",
  "lots": "1-2-4-lots",
  "bid-and-ask-prices": "1-2-5-bid-and-ask-prices",
  "short-long-positions": "1-2-6-short-long-positions",
  "stop-loss-take-profit": "1-2-7-stop-loss-take-profit",
  "pending-orders": "1-2-8-pending-orders",
  "leverage-and-margin": "1-2-9-leverage-and-margin",
  "chart-types": "1-2-10-chart-types",

  "what-s-a-cryptocurrency": "2-1-1-what-s-a-cryptocurrency"
}

